/*eslint-disable */
define(function(require) {
	require('thirdparty/jquery-validate')
	var validationLocalisation 	= require('common/util/validation-localisation');
	validationLocalisation.attachMessages();
})